// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._18zrv77o{padding-inline:var(--ds-space-025,2px)}\n._1rjcv77o{padding-block:var(--ds-space-025,2px)}._16jlkb7n{flex-grow:1}\n._1o9zkb7n{flex-shrink:1}\n._i0dlf1ug{flex-basis:0%}\n._kqswh2mm{position:relative}", ""]);
// Exports
module.exports = exports;
